import React from "react";

interface IRegistrationInputProps {
  title: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  defaultValue: string;
  error: string | null;
}

export function RegistrationInput({
  title,
  onChange,
  placeholder,
  defaultValue,
  error
}: IRegistrationInputProps) {
  return (
    <div className="ch-pt--3 ch-form__group--error">
      <label
        htmlFor="registration"
        className="ch-form__control-label ch-width--12"
      >
        {title}
        {error && <span className="ch-form__control-validation">{error}</span>}
        <input
          id="registration"
          type="text"
          name="registration"
          className="ch-form__control ch-bg--ac-yellow reg-input"
          placeholder={placeholder}
          onChange={onChange}
          defaultValue={defaultValue}
        />
      </label>
    </div>
  );
}
